var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg sticky-top navbar-light bg-light" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "navbarTogglerDemo01" }
        },
        [
          _c("a", { staticClass: "navbar-brand" }, [
            _vm._v("\n      Ciao Vue Dialog\n    ")
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav mr-auto mt-2 mt-lg-0" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-toggle",
                  attrs: { role: "button", "data-toggle": "dropdown" }
                },
                [_vm._v("\n          Example\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-menu" },
                _vm._l(_vm.blocks, function(block) {
                  return _c(
                    "router-link",
                    {
                      key: block.name,
                      staticClass: "dropdown-item",
                      attrs: {
                        to: { name: "demo", query: { block: block.name } }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(block.label) + "\n          "
                      )
                    ]
                  )
                })
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarTogglerDemo01",
          "aria-controls": "navbarTogglerDemo01",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47defefb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47defefb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resource/Nav.vue
// module id = null
// module chunks = 